import React, { Children, useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { GetAppRounded } from "@mui/icons-material";

import { TriggerButton, ThreeBounce } from "commons";

const isEscape = event => event.key === "Escape" || event.key === "Esc";

export function ActionsContainer({ children, isLoading = false }) {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <Container>
            <Button
                onClick={e => {
                    e?.stopPropagation();
                    isLoading ? null : setIsOpen(v => !v);
                }}
                data-testid="action-container-button"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                {isLoading ? (
                    <LoadingIndicator
                        data-testid="download-loading-indicator"
                        size={12}
                        color={"#fff"}
                    />
                ) : (
                    <>
                        <span>Download</span>
                        <StyledIcon
                            aria-hidden="true"
                            fontSize="small"
                            data-testid="download-button-icon"
                        />
                    </>
                )}
            </Button>
            {isOpen && (
                <ChildrenList
                    onClickOutside={() => setIsOpen(false)}
                    onKeyDown={e => isEscape(e) && setIsOpen(false)}
                    data-testid="actions-children-list"
                >
                    {children}
                </ChildrenList>
            )}
        </Container>
    );
}

const ChildrenList = ({ children, onClickOutside, onKeyDown, ...rest }) => {
    useEffect(() => {
        document.addEventListener("click", onClickOutside);
        document.addEventListener("keydown", onKeyDown);

        return () => {
            document.removeEventListener("click", onClickOutside);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [onClickOutside, onKeyDown]);

    return (
        <ChildrenContainer {...rest}>
            {Children.map(children, child => (
                <li>{child}</li>
            ))}
        </ChildrenContainer>
    );
};

const StyledIcon = styled(GetAppRounded)`
    && {
        margin-left: 4px;
    }
`;

const LoadingIndicator = styled(ThreeBounce)`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Container = styled.div`
    position: relative;
`;

const ChildrenContainer = styled.ul`
    position: absolute;
    left: 1rem;
    top: 29px;
    border: 1px solid ${props => props.theme.primary};
    max-width: 130px;
    list-style: none;

    li {
        margin: 0;
    }

    li:not(:first-child) {
        border-top: 1px solid ${props => props.theme.primary};
    }
`;

export const Button = styled(TriggerButton)`
    height: 30px;
    width: 130px;
    max-width: 130px;
    margin-left: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
`;

ChildrenList.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    onClickOutside: PropTypes.func,
    onKeyDown: PropTypes.func
};

ActionsContainer.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
    isLoading: PropTypes.bool
};
